<template>
    <div>
      <Form label-position="left" :label-width="100">
        <FormItem label="留言主题">
          <Col span="10"> <Input ></Input>
          </Col>
        </FormItem>
        <FormItem label="留言内容">
          <Col span="10">
            <Input  type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="输入留言内容"></Input>
          </Col>


        </FormItem>
        <FormItem label="回复方式">
          <Col span="10">  <RadioGroup >
            <Radio label="邮件回复"></Radio>
            <Radio label="电话回复"></Radio>
          </RadioGroup>
          </Col>
        </FormItem>
        <FormItem label="您的姓名">
          <Col span="10"><Input  type="text" ></Input>
          </Col>
        </FormItem>
        <FormItem label="移动电话">
          <Col span="10">
            <Input  type="text" ></Input>
          </Col>
        </FormItem>
        <FormItem label="固定电话">
          <Col span="10">
            <Input  type="text" ></Input>
          </Col>
        </FormItem>
        <FormItem label="电子邮箱">
          <Col span="10">
            <Input  type="text" ></Input>
          </Col>
        </FormItem>
        <FormItem label="验证码" prop="验证码">
          <Col span="10">
            <Input  type="text" ></Input>
          </Col>
          <Col span="5" offset="1">
            <span></span>
          </Col>
        </FormItem>
        <FormItem>
          <Col span="10">
            <Button type="warning" size="">提交</Button>
          </Col>
        </FormItem>
      </Form>
    </div>
</template>

<script>
    export default {
        name: "connect"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/other/components/return.vue